/* eslint-disable no-undef */
import { Common } from '@stockbit/ui';
import { useState } from 'react';
import If from 'global/ErrorHandlers/If';
import QueryProvider from 'global/QueryProvider';

import { EditProfileCard } from '../styled';
import SuccessCard from '../components/SuccessCard';
import VerifyPassword from './VerifyPassword';
import NewEmail from './NewEmail';
import ConfirmOTP from './ConfirmOTP';
import ProgressGuard from '../ProgressGuard';

const { Flex, Iconmoon } = Common;

type ChangeEmailStep = 'verify' | 'change' | 'otp' | 'success';

interface ChangeEmailProps {
  profile: Record<string, any>;
  backLink?: string;
  enableGuard?: boolean;
  backToEditForm?: () => void;
}

function ChangeEmail({
  profile,
  backLink = '/profile/edit',
  backToEditForm = () => {},
}: ChangeEmailProps) {
  const [step, setStep] = useState<ChangeEmailStep>('verify');

  const handleBack = () => {
    if (step === 'verify') {
      backToEditForm();
      return;
    }

    if (step === 'otp') {
      setStep('change');
    }
  };

  const renderTitle = () => {
    const BACK_STEPS = ['verify', 'otp'];
    const showBack = BACK_STEPS.includes(step);

    return (
      <Flex align="center" style={{ gap: 8 }}>
        <If condition={showBack}>
          <Iconmoon
            className="icon-arrow-left"
            onClick={handleBack}
            size="12px"
            style={{ cursor: 'pointer' }}
            data-cy="change-index-back-button"
          />
        </If>
        Ubah Email
      </Flex>
    );
  };

  return (
    <EditProfileCard
      variant="profile-config"
      title={renderTitle()}
      isHideTitle={step === 'success'}
      data-cy="change-index-form"
    >
      <div id="securities-box-changePin" style={{ width: '100%' }}>
        <If condition={step === 'verify'}>
          <VerifyPassword
            onNext={() => setStep('change')}
            cancelLink={'javascript:void(0)'}
            onClickCancel={backToEditForm}
          />
        </If>
        <If condition={step === 'change'}>
          <NewEmail
            email={profile.email}
            onNext={() => setStep('otp')}
            cancelLink={'javascript:void(0)'}
            onClickCancel={backToEditForm}
          />
        </If>
        <If condition={step === 'otp'}>
          <ConfirmOTP onNext={() => setStep('success')} />
        </If>
        <If condition={step === 'success'}>
          <SuccessCard type="email" backLink={backLink} />
        </If>
      </div>
    </EditProfileCard>
  );
}

function ChangeEmailWithProgressGuard(props: ChangeEmailProps) {
  const { enableGuard = false } = props;

  if (!enableGuard) {
    return <ChangeEmail {...props} />;
  }

  return (
    <QueryProvider>
      <ProgressGuard>
        <ChangeEmail {...props} />
      </ProgressGuard>
    </QueryProvider>
  );
}

export default ChangeEmailWithProgressGuard;
